<script>
import UsersApi from "@/services/users-api";
import ClaimApi from "@/services/claim-api";

export default {
    components: {
    },
    mounted(){
        this.getClaimsServices();
        
    },
    data(){
        return{
            pageModalTraders: {currentPage : 1, perPage : 10, totalRows: 0},
            pageModalServices: {currentPage : 1, perPage : 10, totalRows: 0},
            serviceFilter:null,
            isServiceTableBusy:false,
            isUsersTableBusy:false,
            serviceListFields: 
                [                    
                    { key:"creationDate", label: "Date d'ajout",thClass:"",tdClass:"" },
                    { key:"name", label: "Nom",   sortable: false, tdClass:"font-weight-bold  ",},
                    { key:"userName", label: "Utilisateur par défaut",thClass:"",tdClass:"" },
                    { key:"actions", label:"Editer l'utilisateur par défaut"}
                ],
            selectedService:{id:null,name:null,defaultUser:null},
            editServiceModal:false,
            servicesList: [],
            TradersList: [],

            chosenTrader:null,
        }
    },
    methods:{
        cancelServiceEdit(){
            this.selectedService ={id:null,name:null,defaultUser:null};
            this.chosenTrader =null;
            this.editServiceModal=false;
        },
        saveEditedService(){
            if(this.chosenTrader==null || this.chosenTrader.id ==null || this.selectedService == null || this.selectedService.id == null ){
                return ;
            }
            this.isServiceTableBusy = true;
            ClaimApi.updateServiceDefaultUser(this.pageModalServices.currentPage, this.pageModalServices.perPage,
                this.selectedService.id,this.chosenTrader.id ).then(
                    response => {    
                    this.servicesList = response.list
                    this.pageModalServices.totalRows = response.total;
                    this.pageModalServices.currentPage = response.page;
                    this.pageModalServices.perPage = response.pageSize;
                    this.pageModalServices.pageSize = response.pageSize;
                    
                }).finally(() => {
                    this.isServiceTableBusy = false;
                });
            this.selectedService ={id:null,name:null,defaultUser:null};
            this.chosenTrader =null;
            this.editServiceModal = false;
            this.filteredTradersList = [...this.TradersList]; 

        },
        getClaimsServices(){
            this.isServiceTableBusy = true;
            ClaimApi.getClaimsServices(this.pageModalServices.currentPage, this.pageModalServices.perPage,this.serviceFilter,true).then(
                response => {    
                this.servicesList = response.list
                this.pageModalServices.totalRows = response.total;
                this.pageModalServices.currentPage = response.page;
                this.pageModalServices.perPage = response.pageSize;
                this.pageModalServices.pageSize = response.pageSize;
                
            }).finally(() => {
                this.isServiceTableBusy = false;
            });
        },
       
        getTraders(){
           
            this.isUsersTableBusy = true;
            UsersApi.getTradersByService(this.selectedService.id).then(
                  response => {    
                    this.TradersList = response
                   
                  }
            ).finally(() => {
                this.isUsersTableBusy = false;
            });
        },
   
        editService(item){
            if(item == null){
                return;
            }

            this.selectedService={...item};
            this.getTraders();
            this.editServiceModal=true;
        },
       
        selectItem(item) {
            this.chosenTrader = { ...item }
        },
    },


}
</script>

<template>
    <div>
        <div class="row mt-4 pt-4 pb-4">
            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
                <b-form-group :label="$t('subscription.services.nameFilter.label')">
                    <b-input-group  >
                        <b-form-input :placeholder="$t('subscription.services.nameFilter.placeholder')"   v-model="serviceFilter"   @keyup.native.enter="getClaimsServices() "
                            ></b-form-input>                              
                        <template v-slot:append>
                            <b-button variant="primary" @click="getClaimsServices()" >
                            <i class="bx bx-search-alt font-weight-bold font-size-16 text-white align-middle"></i>
                            </b-button>
                        </template>
                    </b-input-group>
                </b-form-group>
            </div>
           
        </div>
        <div class="table-responsive"> 
            <b-table 
                :busy="isServiceTableBusy"
                :striped="true"
                :small="false"
                :hover="true"
                :items="servicesList"
                :fields="serviceListFields"
                :perPage="pageModalServices.perPage"
                class="table">
                <template v-slot:table-busy>
                    <div class="text-center my-2">
                        <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                    </div>
                </template>
                <template v-slot:head(name)>
                    {{ $t("traders.table.service") }} 
            
                </template>
                
                <template v-slot:head(timestamp)>
                    {{ $t("parameters.dateAdd") }} 
                </template>
            
                <template v-slot:cell(timestamp)="{value}">
                    {{value ? value : "_"}}
                </template>
            
            
                <template v-slot:cell(actions)="{item}">
                    <a  title="modifier" href="javascript:void(0);"  @click="editService(item)" class="action-icon text-warning pr-2" >
                        <i class="fas fa-pencil-alt font-size-16"  />
                    </a>
                </template>

            </b-table>
            <span v-if="!isServiceTableBusy && servicesList && !servicesList.length" class="d-flex justify-content-center m-4 text-danger" >{{$t('traders.table.empty')}} </span>

        </div>
        <!-- Pagination -->
        <div class="row pt-3 mb-sm-4">
            <div class="col-sm-8">
                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                    <b-form-select @input="getClaimsServices()"  v-model="pageModalServices.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                    <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }}</span><span class="font-weight-bold"> {{pageModalServices.totalRows}} {{ $t("pagination.lines") }}</span></div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="pageModalServices.currentPage" :disabled="isServiceTableBusy" :per-page="pageModalServices.pageSize" :total-rows="pageModalServices.totalRows" @input="getClaimsServices()" ></b-pagination>
                    </ul>
                </div>
            </div>
        </div> 
        <!-- Fin Pagination  -->
       

    <b-modal
            v-model="editServiceModal"
            :title="  $t('subscription.services.modalheader') + this.selectedService.name " 
            centered 
            hide-footer
            title-class="text-primary"
            title-tag="h5"
            hide-header-close      
            size="lg"
            no-close-on-backdrop
    >

        <div class="mt-5 mb-5">
            <div style="position: relative;
                    display: inline-block;
                    width: 100%;">
                    <ul  v-if="TradersList.length" style=" height: 200px; 
                            width:100%; 
                            overflow-y: auto; 
                            padding: 0;
                            position: relative;
                            z-index: 1000;">
                    <div class="row " style="padding: 0.35rem 1.5rem;">
                        <div class="col-4">{{$t('traders.table.name')}}</div>
                        <div class="col-8 col-lg-6">{{$t('traders.table.userName')}}</div>
                        <div class="col-lg-2 d-none d-lg-flex justify-content-center">Admin</div>
                    </div>

                        <li 
                        v-for="item in TradersList"
                        :key="item.id"
                        @click="selectItem(item)"
                        class="dropdown-item "
                            :class="{'selected-row': chosenTrader && chosenTrader.id == item.id}"
                        >
                            <div class="row">
                                <div class="col-4">{{ item.name }}</div>
                                <div class="col-6">{{ item.userName }}</div>

                                <div class="col-lg-2 d-none d-lg-flex justify-content-center">
                                    <i :class=" item.isAdmin ? 'fas fa-user-graduate font-size-18 text-success' : 'fas fa-user-alt-slash text-danger' " ></i>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <div v-else class="text-muted p-3">
                    {{ $t('lists.trader.empty') }}
                    </div>
            </div>
      </div>
          

            

            
        <div class="row pt-2"> 
            <div v-if="TradersList.length == 0 " class="col-sm-8 col-xs-0"/>
            <div class="col-sm-4 col-xs-12 p-2">
                <b-button variant="secondary" class="w-100 font-weight-bold " @click="cancelServiceEdit">
                    annuler
                </b-button>
            </div>

            <div v-if="TradersList.length != 0"  class="col-sm-4 col-xs-0"/>

            <div v-if="TradersList.length != 0" class="col-sm-4 col-xs-12 p-2">
                <b-button variant="primary" class="w-100 font-weight-bold "  @click="saveEditedService">
                Enregistrer
                </b-button>
            </div>
        </div>

    </b-modal>
       

       


    </div>
</template>
<style scoped>

.selected-row {
  background-color: #00ACC8; 
  color: white; 
  font-weight: bold;
  border-radius: 5px;
}

</style>